import React from 'react';
import { change as changeFieldValue, Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import {
    renderTextArea,
} from '../../util/inputs';
import cadastrarRepasseVenda from '../../actions/reserva/cadastrarRepasseVenda';
import alterarComprovanteRepasseVenda from '../../actions/repasse-venda/alterarComprovanteRepasseVenda';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import { showErrorMsg, showSuccessMsg } from '../../util/messagesUtil';
import baixarComprovanteTransferencia from '../../actions/repasse-venda/baixarComprovanteTransferencia';
import {abaRepasseVenda} from '../../util/constantsUtil';
import buscarRepasseVendaSite from '../../actions/repasse-venda/buscarRepasseVendaSite';

export class ModalRepasseVenda extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.handleChange = this.handleChange.bind(this)
    }

    fecharModal() {
        $('#modalRepasseVenda')
            .modal('hide');
        $('#modalRepasseVenda')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formAlterarFormaPagamento')
    }

    submit(values) {
        if(this.props.repasseVendaSelecionado.id) {
            const repasse = {
                id: this.props.repasseVendaSelecionado.id,
                observacao: values.observacao,
                base64Comprovante: this.props.base64Comprovante,
                nomeComprovanteTransferencia: this.props.nomeComprovante,
            }
            this.props.alterarComprovanteRepasseVenda(repasse)
            .then(() => {
                showSuccessMsg('Comprovante alterado com sucesso!');
                this.fecharModal();
                if(this.props.parametrosBuscaRepasseSelecionado.dataInicio) {
                    this.props.buscarRepasseVendaSite(this.props.parametrosBuscaRepasseSelecionado.dataInicio, this.props.parametrosBuscaRepasseSelecionado.dataFim, this.props.parametrosBuscaRepasseSelecionado.tipo, this.props.parametrosBuscaRepasseSelecionado.aba);
                } else {
                    this.props.buscarRepasseVendaSite(null, null, null, abaRepasseVenda.historicoRepasse);
                }
            })
        } else {
            const repasse = {
                id: this.props.repasseVendaSelecionado.id,
                observacao: values.observacao,
                base64Comprovante: this.props.base64Comprovante,
                nomeComprovanteTransferencia: this.props.nomeComprovante,
                valor: this.props.tipoRepasseVenda == 'EMPRESA' ? this.props.repasseVendaSelecionado.valorLiquido : '' ||
                        this.props.tipoRepasseVenda == 'VENDEDOR' ? this.props.repasseVendaSelecionado.totalComissao : '' ||
                        this.props.tipoRepasseVenda == 'IMPOSTO' ? this.props.repasseVendaSelecionado.totalImposto : '',
                empresaId: this.props.empresaSelecionada.id,
                tipo: this.props.tipoRepasseVenda,
                usuarioId: this.props.repasseVendaSelecionado.usuarioId,
                empresaRepasseId: this.props.repasseVendaSelecionado.empresaId,
                aba: this.props.abaRepasseVendaSelecionada,
                grupo: this.props.repasseVendaSelecionado.grupo
            }
            this.props.cadastrarRepasseVenda(repasse)
            .then(() => {
                showSuccessMsg('Repasse cadastrado com sucesso!');
                this.fecharModal();
                this.props.history.push(`/painel-resumo-repasse?tipo=${this.props.tipoRepasseVenda}`);
            })
        }
    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        if (file.size > tamanhoArquivoUpload) {
            showErrorMsg('Tamanho do arquivo excede 20 MB');
            return
        }
        this.converterParaBase64(file)
    }

    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formRepasseVenda',
                'base64Comprovante', reader.result);
            this.props.changeFieldValue('formRepasseVenda',
                'nomeComprovante', file.name);
        }.bind(this);
    }

    exibirAnexar() {
        if (this.props.base64Comprovante) {
            return (
                    <div className="row align-items-center mt-2">
                        <div className='col-12 label-cancelamento'>
                            <label>Comprovante:</label>
                        </div>
                        <div className='ml-4'>{this.props.nomeComprovante}</div>
                        {this.exibirRemoverComprovante()}
                        {this.exibirBaixarComprovante()}
                    </div>)
        } else {
            return (
                <div>
                    <div className='input-wrapper mt-3'>
                        <label className='btn-laranja' htmlFor='input-file'>
                            <div className='row align-items-center'>
                                <i className="material-icons aberto">&#xe2c3;</i>
                                <strong className='ml-2'>Anexar comprovante de pagamento</strong>
                            </div>
                        </label>
                        <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                         onChange={this.handleChange.bind(this)}/>
                    </div><label style={{ fontSize: 'smaller' }}>
                        * Tamanho máximo permitido : 20 MB
                    </label>
                </div>)
        }
    }

    exibirBaixarComprovante() {
        if (this.props.nomeComprovante) {
            return (
                <button type="button" className="btn btn-editar"
                        title='Baixar'
                        onClick={() => this.baixarComprovante()}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>)
        }
        return '';
    }

    baixarComprovante(){
        baixarComprovanteTransferencia(this.props.base64Comprovante, this.props.nomeComprovante).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.props.nomeComprovante);
            document.body.appendChild(link);

            link.click();

        });
    }

    exibirRemoverComprovante() {
        return (
            <button type="button" className="btn btn-editar"
                title='Remover'
                onClick={() => this.removerArquivo()}>
                <i className="material-icons nav-icon" style={{
                    color: 'red'
                }}>&#xe14c;</i>
            </button>)
    }

    removerArquivo() {
        this.props.changeFieldValue('formRepasseVenda',
            'base64Comprovante', null);
        this.props.changeFieldValue('formRepasseVenda',
            'nomeComprovante', '');
    }

    render() {
        const {
            handleSubmit, submitting
        } = this.props;

        return (
            <div className="modal fade show" role="dialog"
                id="modalRepasseVenda" aria-labelledby="modalRepasseVenda" aria-hidden="true"
                data-backdrop="static">
                <div className="modal-dialog modal-info modal-md modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Repassar {this.props.pedido ? this.props.pedido.id : ''}</h3>
                            <button type="button" className="close" data-dismiss="modal" id="btnFecharModalRepasseVenda"
                                aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <div className="modal-body corpo-modal">
                                <div className="form-group" required={true}>
                                    {this.exibirAnexar()}
                                </div>
                                <div className="form-group">
                                    <Field name="observacao" type="text" component={renderTextArea}
                                        label="Observações:"
                                        css="form-control col-md-12" readOnly={false}
                                        maxLength={2}/>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-laranja" id="btn-confirmar-acesso-auto"
                                    disabled={submitting}>
                                    {this.props.abaRepasseVendaSelecionada === abaRepasseVenda.historicoRepasse
                                        ? 'ALTERAR' : 'CADASTRAR'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        )
    }
}

const seletor = formValueSelector('formRepasseVenda');

export function mapStateToProps(state) {
    return {
        base64Comprovante: seletor(state, 'base64Comprovante'),
        nomeComprovante: seletor(state, 'nomeComprovante'),
        repasseVendaSelecionado: state.repasseVendaSelecionado,
        authentication: state.authentication,
        empresaSelecionada: state.empresaSelecionada,
        repasseVenda: state.repasseVenda,
        parametrosBuscaRepasseSelecionado: state.parametrosBuscaRepasseSelecionado,
        initialValues: {
            nomeComprovante: state.repasseVendaSelecionado.nomeComprovante ? state.repasseVendaSelecionado.nomeComprovante : null,
            base64Comprovante: state.repasseVendaSelecionado.comprovanteTransferencia ? state.repasseVendaSelecionado.comprovanteTransferencia : null,
            observacao: state.repasseVendaSelecionado.observacao ? state.repasseVendaSelecionado.observacao : ''
        }
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarRepasseVenda,
        alterarComprovanteRepasseVenda,
        baixarComprovanteTransferencia,
        buscarRepasseVendaSite
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formRepasseVenda',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalRepasseVenda));
